module.exports = __webpack_public_path__ + "static/media/abbeysomething.91771e0f.jpg";